import React from 'react';

import {
  CloseButton,
  DialogContainer,
  IconWrapper,
  MessageText,
  Overlay,
  MessageTitle,
  ConfirmButton,
} from './styles';

import ICoresData from '../../context/ICoresData';

interface DialogProps {
  icon: React.ReactNode;
  title: string;
  text: string;
  cores: ICoresData;
  onClose: () => void;
}

const MessageDialog: React.FC<DialogProps> = ({
  icon,
  cores,
  title,
  text,
  onClose,
}) => {
  return (
    <Overlay>
      <DialogContainer cores={cores}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <IconWrapper cores={cores}>{icon}</IconWrapper>
        <MessageTitle cores={cores}>{title}</MessageTitle>
        <MessageText>{text}</MessageText>
        <ConfirmButton cores={cores} onClick={onClose}>
          OK
        </ConfirmButton>
      </DialogContainer>
    </Overlay>
  );
};

export default MessageDialog;
